import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IAppConfig } from '@app/store/models/config.interface';
import { Subscription } from 'rxjs';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';
import { APP_CONFIG } from '../../config/config';
import { CoreService } from '../../services/core.service';
import { FunctionsService } from '../../services/functions.service';
import { PaymentService } from '../../services/payment.service';

@Component({
  selector: 'app-core-contact',
  templateUrl: './core-contact.component.html',
  styleUrls: ['./core-contact.component.scss']
})
export class CoreContactComponent implements OnInit {

  error: string
  processing = false

  data: FormGroup<_CoreContactForm>
  modal_element: any
  session_info: SessionInfo
  private subscriptions: Subscription[] = []
  subjects = this.coreService.supportTickets()

  constructor(
    private httpClient: HttpClient,
    public coreService: CoreService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    public functionService: FunctionsService,
    public readonly paymentService: PaymentService,
    private qrGeneratorService: UserQrGeneratorService,
    @Inject(APP_CONFIG) private readonly config: IAppConfig
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
  }

  ngOnInit(): void {
    this.fillFormData()
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }

  private async fillFormData() {
    let purpose = this.subjects.find(sub => sub.id === 6)
    const initsubject = await this.functionService.getQueryString(this.activatedRoute, "reason")
    if (initsubject && this.subjects.find(sub => sub.id === +initsubject)) purpose = this.subjects.find(sub => sub.id === +initsubject)
    this.data = this.formBuilder.group({
      recaptcha_token: [""],
      message: ["", [Validators.required]],
      subject: [purpose.description, [Validators.required]],
      name: [this.session_info?.user_details?.name, [Validators.required]],
      email: [this.session_info?.user_details?.email, [Validators.required, Validators.email]],
    })
  }

  async submitRequest() {
    if (this.processing) return
    this.data.markAllAsTouched()
    if (!this.data.valid) {
      this.functionService.logToConsole(this.data.errors)
      this.qrGeneratorService.scrollToFirstInvalidControl()
      return
    }

    this.processing = true;
    const data = this.data.value
    try {
      data.recaptcha_token = await this.coreService.getRecaptchaToken()
      await this.httpClient.post(this.config.apiEndpoints.user.support, data).toPromise()
      this.functionService.showSuccessMessage("Request successfully submitted!")
      this.fillFormData()
    } catch (error) {
      this.error = error?.error?.error || "Something went wrong while submitting your request"
    }
    this.processing = false;
  }

}

interface _CoreContactForm {
  name: FormControl<string>;
  email: FormControl<string>;
  message: FormControl<string>;
  subject: FormControl<string>;
  recaptcha_token: FormControl<string>;
}
